/**
 * 首页 Hero：背景视频播放后，主文案与顶栏在加载时渐入显现（非滚动触发）。
 *
 * `HOME_HERO_REVEAL_EVENT` 由 HeroSection 在揭晓时派发，Header 监听以保持与主内容同步。
 */
export const HOME_HERO_LOAD_REVEAL_DELAY_S = 1.8;

/** 用于刷新/深链时已滚离首屏时，顶栏与 Hero 直接显示终态 */
export const HOME_HERO_REVEAL_SCROLL_PX = 8;

export const HOME_HERO_REVEAL_EVENT = "home-hero-reveal";
